export const scrolltop = {
  css: () => `
    .p-scrolltop {
      border-radius: 5px !important;
    }
  `,
};
